module.exports = __webpack_public_path__ + "img/2.cf96ec3b.png";